<template lang="pug">
  .product-ingredients-details
    #whats-in-our-color.sm-10.sm-push-1.mt-em-0-5.mb-em-0-5
      .info-wrap.flex-box.column.mb-em-1-75
        p.intro-text.xs-f-small.lg-f-small.max-at-tweak.text-center.mb-em-1
          | Learn more about our&nbsp;
          a(href="/hair-dye-ingredients" class="underline" target="_self") ingredient philosophy
          | .
        .leaping-bunny-img.a-box-xs-1x1
          .a-box-content
            img-box(media-id="4227")
        p.leaping-bunny-text.xs-f-small.lg-f-small.max-at-tweak.text-center.align-center.mb-em-3
          | Join us against animal cruelty.&nbsp;
          a(href="/blog/join-us-against-animal-cruelty" class="underline" target="_self") Learn more
          |  about our cruelty-free Leaping Bunny certification.
        .info(v-for="item in productProperties")
          h3.semi-bold.xs-f-small.capitalize.max-at-tweak.text-left.mb-em-0-3 {{ item.title }}
          p.xs-f-small.capitalize.max-at-tweak.mb-em-1-5 {{ product[item.accessor] }}

</template>

<script>
  export default {
    name: 'ProductIngredientsDetails',
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    data: () => {
      return {
        productProperties: [
          { title: 'Radiant Cream Color',
            accessor: 'ingredientDesc1'
          },
          { title: 'Color Activator',
            accessor: 'ingredientDesc2'
          },
          { title: 'Barrier Cream',
            accessor: 'ingredientDesc3'
          },
          { title: 'Cleansing Wipes',
            accessor: 'ingredientDesc4'
          },
          { title: 'Color-Protecting Shampoo',
            accessor: 'ingredientDesc5'
          },
          { title: 'Color-Protecting Conditioner',
            accessor: 'ingredientDesc6'
          },
        ]
      }
    }
  };
</script>

<style scoped lang="stylus">
  .product-ingredients-details
    #whats-in-our-color
      padding 1.5em 5%
    
      .info-wrap
        .intro-text
        .leaping-bunny-img
        .leaping-bunny-text
          align-self center
        
        .leaping-bunny-img
          width 5em
    
    @media mq-mobile
      #whats-in-our-color
        overflow auto
      
</style>
